import conferenceHall from '@/assets/img/users-cases/conference-hall.webp';
import conferenceHallHow from '@/assets/img/users-cases/conference-hall-how.webp';
import conferenceHallResult from '@/assets/img/users-cases/conference-hall-result.webp';

export default {
  slug: 'conference-hall',
  order: 13,
  title: 'Conference Hall 3D View',
  subtitle: 'Wide-angle 3D renderings and 360° hall views',
  tags: ['officedesign', 'conferencehall'],

  images: {
    hero: conferenceHall,
    aboutTop: conferenceHallHow,
    aboutBottom: conferenceHallResult,
  },

  howText:
    'Created 2D and 3D floor plans for flexible conference layouts, including seating arrangements, presentation areas, and breakout zones. Interior design incorporates lighting, furniture, and materials that communicate functionality and prestige.',

  resultText:
    'Developers can immediately use the plans for client presentations, marketing materials, and investor approvals, accelerating lease or sale of commercial event spaces and improving project credibility.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
